import { render } from "./CreatorTc.vue?vue&type=template&id=b5a63f00"
import script from "./CreatorTc.vue?vue&type=script&lang=js"
export * from "./CreatorTc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__